import React from 'react';
import { Navigate, useParams, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.js';

// Consolidation shims: the old scattered analytics screens now live in the
// unified profile / Performance hub. These keep any old links/bookmarks working
// by forwarding to the new home, role-appropriately.

// /stats → staff see the team Performance hub; athlete/parent see the profile.
export function StatsRedirect() {
  const { user } = useAuth();
  const staff = ['admin', 'coach', 'superadmin', 'staff'].includes(user?.role);
  return <Navigate to={staff ? '/performance' : '/athlete-card/me?tab=performance'} replace />;
}

// /athlete-performance/:id → the athlete's profile Performance tab.
export function AthletePerfRedirect() {
  const { id } = useParams();
  return <Navigate to={id ? `/athlete-card/${id}?tab=performance` : '/athletes'} replace />;
}

// /athlete/:id (legacy full profile) → the unified profile hub, carrying any
// ?tab=/&date= deep-link (e.g. the video review list opens ?tab=videos&date=).
export function AthleteProfileRedirect() {
  const { id } = useParams();
  const [sp] = useSearchParams();
  const qs = sp.toString();
  return <Navigate to={id ? `/athlete-card/${id}${qs ? `?${qs}` : ''}` : '/athletes'} replace />;
}
